import { get } from 'lodash-es'
import {
  logKow,
  mpbp,
  wsKow,
  waterNt,
  vp,
  hlc,
  logKoa,
  biowin,
  bioHcWin,
  logKoc,
  atmosphericHalfLife,
  bcfBaf,
  wvolWin,
  hydroWin,
  dermWin,
  aeroWin,
  stpWin,
  fugacity,
  ecosar,
} from '@/components/combined-predict/models/epiSuite/components/EpiSuiteCard/mappers'

const propertyToCardFunction = {
  logKow: logKow,
  meltingPoint: mpbp,
  boilingPoint: mpbp,
  waterSolubilityFromLogKow: wsKow,
  waterSolubilityFromWaterNt: waterNt,
  vaporPressure: vp,
  henrysLawConstant: hlc,
  logKoa: logKoa,
  biodegradationRate: biowin,
  hydrocarbonBiodegradationRate: bioHcWin,
  logKoc: logKoc,
  atmosphericHalfLife: atmosphericHalfLife,
  bioconcentration: bcfBaf,
  waterVolatilization: wvolWin,
  hydrolysis: hydroWin,
  dermalPermeability: dermWin,
  aerosolAdsorptionFraction: aeroWin,
  sewageTreatmentModel: stpWin,
  fugacityModel: fugacity,
  ecosar: ecosar,
}

const getEpiSuiteCardMapper = (property) => get(propertyToCardFunction, property, null)

export { getEpiSuiteCardMapper }
